import { forwardRef, useCallback, useState, useMemo } from "react";
import { Div, Label, InputWrapperDiv, InputField, AdornmentWrapperDiv, ErrorText, PasswordControlButton } from "./input.style";

const Input = forwardRef(
    (
        {
            id,
            name,
            type = "text",
            label,
            required,
            value,
            error,
            fullWidth,
            className,
            onChange,
            startAdornment,
            endAdornment,
            isMobile,
            ...remainingProps
        }, ref
    ) => {
        const labelId = label ? `${id}-label` : undefined;
        const errorId = error ? `${id}-error-text` : undefined;

        const [showPassword, setShowPassword] = useState(false);

        const handleChange = useCallback(
            (event) => {
                onChange(event);
            },
            [onChange]
        );

        const PasswordControl = useMemo(
            () => (
                <div onClick={() => setShowPassword(!showPassword)}>
                    {showPassword ? (
                        <PasswordControlButton>hide</PasswordControlButton>
                    ) : (
                        <PasswordControlButton>show</PasswordControlButton>
                    )}
                </div>
            ),
            [setShowPassword, showPassword]
        );

        return (
            <Div fullWidth={fullWidth}>
                {label && (
                    <Label id={labelId} htmlFor={id}>
                        {`${label}${required ? "*" : ""}`}
                    </Label>
                )}
                <InputWrapperDiv>
                    {startAdornment && <AdornmentWrapperDiv className="search">{startAdornment}</AdornmentWrapperDiv>}
                    <InputField
                        id={id}
                        ref={ref}
                        name={name}
                        endAdornment={endAdornment}
                        type={showPassword ? "text" : type}
                        value={value}
                        required={required}
                        aria-invalid={!!error}
                        aria-describedby={errorId}
                        onChange={handleChange}
                        className={className}
                        error={error}
                        isMobile={isMobile}
                        {...remainingProps}
                    />
                    {endAdornment && (
                        <AdornmentWrapperDiv className="end">
                            {type === "password" ? PasswordControl : endAdornment}
                        </AdornmentWrapperDiv>
                    )}
                </InputWrapperDiv>
                {error && (
                    <ErrorText
                        initial="pageInitial"
                        animate="pageAnimate"
                        exit="pageExit"
                        variants={{
                            pageInitial: {
                                opacity: 1,
                                x: 0,
                                y: -5,
                            },
                            pageAnimate: {
                                opacity: 1,
                                x: 0,
                                y: 0,
                            },
                            pageExit: {
                                opacity: 0,
                            },
                        }}
                        id={errorId}
                    >
                        {error}
                    </ErrorText>
                )}
            </Div>
        )
    })

export { Input }
